<template>

    <div class="row">
        <div class="col-sm-4 col-sm-offset-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">CRM groep {{ crmgroup !== null ? 'wijzigen' : 'toevoegen' }}</h2>
                </div>
                <div class="box-body">
                    <text-input
                        :error="errors.get('name')"
                        label="Naam"
                        v-model="form.name"
                    ></text-input>

                    <div class="text-right">
                        <button
                            class="btn btn-primary"
                            :disabled="!canSubmit"
                            @click="onSubmit()"
                        >
                            Opslaan
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';
import Errors from "../../../Errors";
import TextInput from "../../../components/Common/Form/TextInput";

export default {

    components: {
        TextInput,
    },

    computed: {

        ...mapGetters([
            'getCrmGroups',
        ]),

        canSubmit() {
            return this.posting === false;
        },

        crmgroup() {
            if (!this.$route.params.uuid) {
                return null;
            }

            let crmgroup = this.getCrmGroups.filter(crmgroup => crmgroup.uuid === this.$route.params.uuid);

            return crmgroup.length !== 1 ?
                null :
                crmgroup[0];
        },

    },

    data() {
        return {
            errors:new Errors(),
            form: {
                name:'',
            },
            posting:false,
        }
    },

    metaInfo: {
        title:'CRM groep formulier',
    },

    methods: {

        onSubmit() {
            if (!this.canSubmit) {
                return;
            }

            this.posting = true;

            let url = this.crmgroup === null ?
                this.route('api.v1.crm.groups.store') :
                this.route('api.v1.crm.groups.update', {group_uuid: this.crmgroup.uuid});

            axios.post(url, this.form)
                .then(() => {
                    this.$emit('updateCrmGroups');

                    if (this.costcode === null) {
                        this.$snotify.success('De nieuwe CRM groep is toegevoegd');
                    } else {
                        this.$snotify.success('De CRM groep is opgeslagen');
                    }

                    this.$router.push({name:'crm.groups.index'});
                })
                .catch(err => {
                    if (err.response.data.errors) {
                        this.errors.record(err.response.data.errors);
                        this.$snotify.error('Er zijn fouten in het formulier gevonden!');
                    } else {
                        this.$snotify.warning('Er is een fout opgetreden! Probeer het opnieuw');
                    }
                })
                .finally(() => this.posting = false);
        },

        setFormData() {
            if (this.crmgroup !== null) {
                this.form.name = JSON.parse(JSON.stringify(this.crmgroup.name));
            }
        },
    },

    mounted(){
        this.setFormData();
    },

    name:'CrmGroupsForm',

}

</script>
